import { CheckboxFormikField, Link } from "@certn/cascadia-react";
import {
  getApplicantPortalTermsOfUseUrl,
  getApplicantRegistrationPrivacyPolicyUrl,
} from "@certn/utils";
import { Trans, useTranslation } from "react-i18next";

type ClickwrapCheckBoxTypes = {
  testID?: string;
};

export function ClickwrapCheckBox(props: ClickwrapCheckBoxTypes) {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const privacyPolicyUrl = getApplicantRegistrationPrivacyPolicyUrl(language);
  const applicantPortalTermsOfUseUrl =
    getApplicantPortalTermsOfUseUrl(language);

  return (
    <CheckboxFormikField
      name="agreed_to_terms_and_conditions"
      isRequired
      testID={props.testID ?? "clickwrap-checkbox"}
    >
      <Trans>
        I have read and agree to Certn's{" "}
        <Link
          linkStyle="monochrome"
          textColor="text-weak"
          href={privacyPolicyUrl}
          testID="clickwrap-contract-link"
          target="_blank"
        >
          Privacy Policy
        </Link>{" "}
        and{" "}
        <Link
          linkStyle="monochrome"
          textColor="text-weak"
          href={applicantPortalTermsOfUseUrl}
          testID="clickwrap-contract-link"
          target="_blank"
        >
          Applicant Terms
        </Link>
        .
      </Trans>
    </CheckboxFormikField>
  );
}
